import React from "react";

interface DashboardCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: string;
  id?: string;
}

export default function DashboardCard({
  children,
  className = "",
  padding,
  id,
}: DashboardCardProps) {
  return (
    <div
      id={id}
      className={`w-full box-border rounded-[20px] border border-white/[0.08] bg-[#161b22] shadow-[0_8px_32px_rgba(0,0,0,0.4)] text-[#f0f6fc] ${className}`}
      style={padding ? { padding } : undefined}
    >
      {children}
    </div>
  );
}
